<template>
    <div class="public_bg">
      <div class="nurse_top">
        <div style="height:54px;line-height:54px;">
          <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
          <span>跌倒设备管理</span>
        </div>
      </div>
      <div class="row_link clearfix">
        <div class="item" v-for="(item,index) in infoList" :key="index" @click="handleClick(item)">
          <a>
            <img :src="item.img" />
            <h5 style="font-size:16px;">{{item.title}}</h5>
            <span>{{item.text}}</span>
          </a>
        </div>
      </div>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  export default {
    name: "doorManagement",
    data() {
      return {
        infoList: [] //数据源
      };
    },
    methods: {
      //点击每个
      handleClick(item) {
        bus.$emit("homePage", {
              type: "jump",
              path: item.url,
              title: item.title
            });
            
      },
      /**
       * 获取菜单栏的数据列表
       */
      getPageData() {
        this.infoList = [
          {
            img:require("@/assets/beadhouse/rentiganying.png"),
            title:'跌倒雷达',
            text:'跌倒雷达管理',
            uid:1,
            url:'/FallRadarList'
          },{
            img:require("@/assets/beadhouse/yingshiCamera.png"),
            title:'奥瞳摄像头',
            text:'奥瞳摄像头管理',
            uid:2,
            url:'/AotongCamera'
          }
        ];
  
      }
    },
    created() {
      this.getPageData();
    },
    mounted() {}
  };
  </script>
  <style lang="scss" scoped>
  .public_bg {
    width: 100%;
    height: 95%;
    padding: 0 0 20px 0;
    background: #fefefe;
    .nurse_top {
      border: 1px #f1eff2 solid;
      background: #f9f7fa;
      position: relative;
      img {
        margin: 14px 12px;
      }
      h5 {
        display: inline-block;
        position: absolute;
        top: 12px;
        font-size: 18px;
      }
    }
    .row_link {
      width: 1259px;
  
      margin: 34px 35px;
      .item {
        width: 275px;
        height: 99px;
        border: #f0f0f2 1px solid;
        margin-bottom: 34px;
        margin-right: 34px;
        float: left;
        cursor: pointer;
        img {
          float: left;
          margin: 8px 23px 8px 33px;
          margin-right: 16px;
        }
        span {
          color: #666666;
        }
        h5 {
          margin-top: 21px;
          margin-bottom: 8px;
        }
        a:hover {
          color: #333;
        }
      }
      .item:hover {
        border: 1px solid red;
      }
    }
  }
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .clearfix {
    *zoom: 1;
  }
  </style>
  